import { Transaction, TransactionServer, TransactionsList, TransactionsListServer } from '../store/types';

export const adapteTransaction = (res: TransactionServer): Transaction => ({
  id: res.id,
  userId: res.user_id,
  created: res.created,
  type: res.type,
  amount: res.amount,
  balanceBefore: res.balance_before,
  balanceAfter: res.balance_after,
});

export const adapteTransactionsList = (res: TransactionsListServer): TransactionsList => ({
  items: res.items.map(adapteTransaction),
  count: res.count,
});
